import React from "react";

import styles from "./styles.module.scss";

const Note: React.FC = ({ children }) => {
  return <div className={styles.note}>{children ?? children}</div>;
};

export default Note;
